import {
  ProfileAPIClient,
  ProfileRequestService,
  UserProfile,
} from 'frontcore/domain/profile/model/Profile.d'

export default class ProfileRequestServiceImpl implements ProfileRequestService {

  readonly #profileAPIClient: ProfileAPIClient

  constructor (profileAPIClient: ProfileAPIClient) {
    this.#profileAPIClient = profileAPIClient
  }

  async retrieve (token: string): Promise<UserProfile> {
    return await this.#profileAPIClient.request(token)
  }

}
